export default __webpack_public_path__ + "static/media/lens.7acaf63b.svg";